/**
 * When the invoices are due — the one sentence under When you pay
 * (`docs/visits-billing-and-proposal.md` §9.4, W8, D6).
 *
 * Drawn with the timeline's own `Note`, exactly as the estimate note is, and
 * worded by `invoiceTermsSentence()` in shared, which is the only place the
 * sentence exists. Nothing when the chosen plans disagree: the invoice will
 * say, and a guess on a page somebody signs is worse than silence.
 *
 * Aaron: to say nothing about terms on the proposal, delete the one
 * `<TermsNote/>` line in `payments-timeline.tsx` and test T8.
 */
import { invoiceTermsSentence, type InvoiceTerms } from '@rowted/shared'
import { Note } from './payments-timeline.js'

export function TermsNote({ terms }: { terms: InvoiceTerms | null }) {
  if (!terms) return null
  return <Note>{invoiceTermsSentence(terms)}</Note>
}
